import { APIManager } from "shared/manager";
import { RestEnds } from "../shared/Constants";
import AxiosManager from "shared/manager/AxiosManager";

// const addSecurity = async (data, loanId, securityId) => {
//   return APIManager.sendPost(
//     `${RestEnds.SECURITY}/${loanId}/${securityId}/add`,
//     AxiosManager,
//     data,
//     true,
//     {},
//     {}
//   );
// };

const addSecurity = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.SECURITY}/${loanId}/add`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

export const SecurityService = {
  addSecurity,
};
